<template>
    <el-dialog title="新增" :visible.sync="FeeFileConfigureAddDalogFlag" :destroy-on-close="true" width="28%" top="70px"
        style="text-align: center">
        <el-form ref="addServicesForm" :model="addForm" :rules="formRules" label-width="90px">
            <el-form-item label="仓库" prop="warehouseId">
                <el-select v-model="addForm.warehouseId" style="width: 100%" placeholder="请选择仓库">
                    <el-option v-for="item in warehouseList" :label="item.label" :value="item.value"
                        :key="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="quoteType" label="报价类型" prop="feeScope">
                <el-radio-group v-model="addForm.feeScope">
                    <el-radio :label="0">公共报价</el-radio>
                    <el-radio :label="1">自定义报价</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="客户货主" prop="orgId" v-if="addForm.feeScope" >
                <el-select v-model="addForm.orgId" style="width: 100%" placeholder="请选择客户货主">
                    <el-option v-for="item in customList" :label="item.label" :value="item.value"
                        :key="item.value"></el-option>
                </el-select>
                
            </el-form-item>
            <el-form-item label="报价文件" prop="fileList" class="customerClass">
                <el-link :underline="false" @click="downFile" type="primary">下载模板</el-link>
                <el-upload class="uploadFile" ref="upload" action="" accept=".xls,.xlsx,.csv,.xlsm"
                    :on-change="handleChange" :file-list="addForm.fileList" :on-remove="handleRemove" :auto-upload="false">
                    <el-link :underline="false" type="primary" slot="trigger">导入报价</el-link>
                </el-upload>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSubmit" :loading="addLoading">确定</el-button>
                <el-button @click.native="FeeFileConfigureAddDalogFlag = false" :loading="addLoading">取消</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>
  
<script>
import {
    ImportFeeFile,
    WesternTemplate,
} from "@/api/costManagement/FeeFileConfigure.js";
import { urlEncode, deleteJsonEmptyProps } from "util/util";
export default {
    props: ['warehouseList', 'customList'],
    data() {
        return {
            fileList: [],
            addForm: {},
            FeeFileConfigureAddDalogFlag: false,
            addLoading: false,
            formRules: {
                warehouseId: [{ required: true, message: "请选择仓库", trigger: "change" }],
                feeScope: [{ required: true, message: "请选择报价类型", trigger: "change" }],
                orgId: [{ required: true, message: "请选择客户货主", trigger: "change" }],
                fileList: [{ required: true, message: "请选择文件", trigger: "change" }],
            },
        };
    },
    methods: {
        downFile() {
            let url = WesternTemplate;
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            document.body.appendChild(link);
            link.click();
        },
        handleChange(file, fileList) {
            this.addForm.fileList = [fileList.at(-1)]
        },
        handleRemove(file) {
            this.addForm.fileList = []
        },
        showDalog() {
            this.addForm = {
                feeScope: 0,
                fileList: [],
                warehouseId: undefined,
                orgId: undefined
            }
            this.FeeFileConfigureAddDalogFlag = true;
        },
        onSubmit() {
            this.$refs.addServicesForm.validate((valid) => {
                if (valid) {
                    let { warehouseId, feeScope, orgId } = this.addForm
                    let params = { warehouseId, feeScope, orgId }
                    const formData = new FormData();
                    formData.append('file', this.addForm.fileList[0].raw)
                    this.addLoading = true;
                    ImportFeeFile(formData, urlEncode(deleteJsonEmptyProps(params))).then((res) => {
                        this.addLoading = false;
                        if (res.data.success) {
                            this.$refs["addServicesForm"].resetFields();
                            this.$message({
                                message: res.data.msg || "操作成功",
                                type: "success",
                            });
                            this.FeeFileConfigureAddDalogFlag = false;
                            this.$emit("searchTable", "");
                        } else {
                            this.$message({
                                message: res.data.msg || "操作失败",
                                type: "error",
                            });
                        }
                    })
                }
            });
        },

    },
    mounted() {

    },
};
</script>

<style lang="less" scoped>
.quoteType {
    .el-radio-group {
        display: flex;
        align-items: center;
        height: 36px;
    }
}

.customerClass {
    ::v-deep .el-form-item__content {
        display: flex;

        >.el-select {
            flex: 1;
            margin-right: 10px;
        }
    }
    ::v-deep .el-link--primary{
        align-items: flex-start;
    }
}

::v-deep.uploadFile {
    text-align: left;
    margin-left: 4px;
}
</style>
  
  